'use client';

import { useCallback, useEffect, useRef, useState } from 'react';
import type { Tab } from './use-modal-state';

export function useScrollIndicator(activeTab: Tab) {
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);

  const checkScrollPosition = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    setIsScrolledToBottom(el.scrollHeight - el.scrollTop - el.clientHeight < 8);
  }, []);

  useEffect(() => {
    setIsScrolledToBottom(false);
    if (activeTab !== 'details') return;
    const frame = requestAnimationFrame(checkScrollPosition);
    return () => cancelAnimationFrame(frame);
  }, [activeTab, checkScrollPosition]);

  return {
    scrollRef,
    checkScrollPosition,
    showGradient: activeTab === 'details' && !isScrolledToBottom,
  };
}
